import { ACTIVE_SIDE_LISTINGS_ONLY_STATES } from '@/views/Community/constants';
import type { AuditRequest } from '$api-clients/hooks';

type Audits = AuditRequest<'/interactions/{interactionId}/audits'>['Data'];

/**
 * Whether the interaction's audit still permits manual status transitions out
 * of a terminal status: true when there is no audit or the earliest-created
 * audit is still in its early `CREATED` state.
 */
export const oldestAuditAllowsManualTransition = (
  audits: Audits | undefined,
): boolean => {
  if (!audits || audits.length === 0) return true;

  const oldestAudit = audits.reduce((oldest, audit) =>
    audit.createdAt < oldest.createdAt ? audit : oldest,
  );

  return oldestAudit.status === 'CREATED';
};

const ACTIVE_SIDE_LISTING_STATUSES = ['active', 'activeCont', 'onMarket'];

const SIDE_LISTING_STATUSES = [
  'active',
  'activeCont',
  'onMarket',
  'offMarket',
  'comingSoon',
];

export const isCommunityListingStatus = ({
  status,
  market,
}: {
  status: string;
  market: string;
}) => {
  if (ACTIVE_SIDE_LISTINGS_ONLY_STATES.has(market)) {
    return ACTIVE_SIDE_LISTING_STATUSES.includes(status);
  }

  return SIDE_LISTING_STATUSES.includes(status);
};

export const togglingCommunityListingPromotionCard = ({
  oldStatus,
  newStatus,
  market,
}: {
  oldStatus: string;
  newStatus: string;
  market: string;
}) =>
  isCommunityListingStatus({ status: newStatus, market }) !==
  isCommunityListingStatus({ status: oldStatus, market });
